// Subscription detection logic

const productInfoContainer = document.querySelector('.product__info-container');
const productPrice = productInfoContainer ? productInfoContainer.getAttribute('data-productprice') : null;
const productComparePrice = productInfoContainer ? productInfoContainer.getAttribute('data-productcompareprice') : null;
const isBundle = productInfoContainer ? productInfoContainer.getAttribute('data-isbundle')?.includes('Bundles') : false;
const isTandoor = document.querySelector('.template-product-tandoor-bundles') ? true : false;
const isPreOrder =  productInfoContainer?.getAttribute('data-ispreorder');
const isAvailable =  productInfoContainer?.getAttribute('data-isavailable'); 
const addToCartText = document.querySelector('.addToCartText');
const addToCartOriginalText = addToCartText?.textContent;

const addToCartComparePrice = document.querySelector('.addToCartComparePrice');
const addToCartPrice = document.querySelector('.addToCartPrice');

let onSubscription = false;
let currentQuantity = 1;
let quantityDiscount = 1;
let subscriptionDiscount = 0.85;

const checkSubscriptionState = () => {
  const subscriptionWidget = document.querySelector('recharge-subscription-widget');
  if (!subscriptionWidget) return false;
  
  const shadowRoot = subscriptionWidget.shadowRoot;
  if (!shadowRoot) return false;
  
  const selectedOption = shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
  onSubscription = selectedOption ? selectedOption.classList.contains('rc-purchase-option__subscription') : false;
  
  return onSubscription;
};

// Sticky bar layout: shrink the title bar / lower the selector when one-time is picked.
// Only takes visual effect at <= 990px (values live in CSS); classes toggle at all widths.
const ONETIME_PT_CLASS = 'fixedOnScrollPT--onetime';
const ONETIME_RC_CLASS = 'fixedOnScroll--onetime';

const isOneTimeSelected = () => {
  const subscriptionWidget = document.querySelector('recharge-subscription-widget');
  const shadowRoot = subscriptionWidget?.shadowRoot;
  if (!shadowRoot) return false;

  const selectedOption = shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
  if (!selectedOption) return false;

  return !selectedOption.classList.contains('rc-purchase-option__subscription');
};

const updateStickyOneTimeLayout = () => {
  const oneTime = isOneTimeSelected();

  const productTitle = document.querySelector('.fixedOnScrollPT');
  productTitle?.classList.toggle(ONETIME_PT_CLASS, oneTime);

  const subscriptionWidget = document.querySelector('recharge-subscription-widget');
  const rechargeRoot = subscriptionWidget?.shadowRoot?.querySelector('.fixedOnScroll');
  rechargeRoot?.classList.toggle(ONETIME_RC_CLASS, oneTime);
};

const getCurrentQuantity = () => {
  const checkedElement = document.querySelector('.var_title.checked');
  if (checkedElement) {
    return parseInt(checkedElement.getAttribute('data-quantity')) || 1;
  }
  return 1;
};

// Update widget prices when quantity changes

const originalWidgetPrices = {};

const updateRechargeWidgetPrices = () => {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget || !widget.shadowRoot) return;

  const selectors = {
    base: '.rc-purchase-option:not([class*="subscription"]) .rc-price:not(.strike-through)',
    compare: '.rc-price.strike-through',
    subscription: '.rc-purchase-option[class*="subscription"] .rc-price:not(.strike-through)'
  };

  Object.entries(selectors).forEach(([key, selector]) => {
    const span = widget.shadowRoot.querySelector(selector);
    if (!span) return;

    const priceNode = span.childNodes.length === 1
      ? span
      : Array.from(span.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim().includes('£'));

    if (!priceNode) return;

    if (!(key in originalWidgetPrices)) {
      const match = priceNode.textContent.match(/£\s*([\d.]+)/);
      if (!match || match.length < 2) return;
      const baseValue = parseFloat(match[1]);
      if (isNaN(baseValue)) return;
      originalWidgetPrices[key] = baseValue;
    }

    // Check if this is a subscription price or compare price
    const isSubscriptionPrice = key.toLowerCase().includes('subscription');
    const isComparePrice = key === 'compare';
    
    // Apply different calculation based on price type
    let newPrice;
    if (isSubscriptionPrice) {
      // Case 1: Subscription price - no quantity discount applied
      newPrice = (originalWidgetPrices[key] * currentQuantity * ((1 / 0.85) * (subscriptionDiscount))).toFixed(2);
    } else if (isComparePrice) {
      // Case 2: Compare price - no quantity discount applied
      newPrice = (originalWidgetPrices[key] * currentQuantity).toFixed(2);
    } else {
      // Case 3: Regular price - apply quantity discount
      newPrice = (originalWidgetPrices[key] * currentQuantity * quantityDiscount).toFixed(2);
    }
      
    priceNode.textContent = `£${newPrice}`;
  });
};


const setPrices = () => {
  currentQuantity = getCurrentQuantity();
  checkSubscriptionState();

  if (currentQuantity === 4) {
    quantityDiscount = 0.95;
    subscriptionDiscount = 0.85;
  } else if (currentQuantity === 6) {
    quantityDiscount = 0.9;
    subscriptionDiscount = 0.8;
  } else {
    quantityDiscount = 1;
    subscriptionDiscount = 0.85;
  }

  if(isBundle || isTandoor) {
    quantityDiscount = 1; 
  }



  if(onSubscription) {
    if (!isPreOrder && isAvailable) {
      addToCartText.textContent = 'SUBSCRIBE';
    } 
  } else {
    addToCartText.textContent = addToCartOriginalText;
  }

  if(onSubscription) {
    if(addToCartComparePrice && productComparePrice) {
      addToCartComparePrice.textContent = '£' + (productComparePrice * currentQuantity).toFixed(2);
    } else if(addToCartComparePrice) {
      addToCartComparePrice.textContent = '£' + (productPrice * currentQuantity).toFixed(2);
    }
  
    if(addToCartPrice) {
      addToCartPrice.textContent = '£' + ((productPrice * subscriptionDiscount) * currentQuantity).toFixed(2);
    }
  } else {
    if(addToCartComparePrice && productComparePrice) {
      addToCartComparePrice.textContent = '£' + (productComparePrice * currentQuantity).toFixed(2);
    } else if(addToCartComparePrice) {
      addToCartComparePrice.textContent = '£' + (productPrice * currentQuantity).toFixed(2);
    }
  
    if(addToCartPrice) {
      addToCartPrice.textContent = '£' + ((productPrice * quantityDiscount) * currentQuantity).toFixed(2);
    }
  }


  if (addToCartComparePrice && addToCartPrice && addToCartComparePrice.textContent === addToCartPrice.textContent) {
    addToCartComparePrice.textContent = '';
  }

  // Handle bundle display
  if(isBundle) {
    document.querySelectorAll('.product .variant_lists .vartitleDiscount').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.product .variant_lists .vartitleDiscountSubscription').forEach(el => {
      el.style.display = onSubscription ? 'flex' : 'none';
    });
  } else {
    document.querySelectorAll('.product .variant_lists .vartitleDiscount').forEach(el => {
      el.style.display = onSubscription ? 'none' : 'flex';
    });
    document.querySelectorAll('.product .variant_lists .vartitleDiscountSubscription').forEach(el => {
      el.style.display = onSubscription ? 'flex' : 'none';
    });
  }

  updateRechargeWidgetPrices();

  updateStickyOneTimeLayout();

};

// Start continuous price updates
setInterval(setPrices, 300);








// Styles logic
const applyStyles = (shadow) => {
  const style1 = document.createElement('style');
  style1.textContent = `
    .rc-purchase-option {
      border: none !important;
      background: transparent !important;
      margin-bottom: 0 !important;
    }

    .compact.rc-selection__root {
      font-family: 'Masqualero', sans-serif !important;
      font-size: 20px !important;
    }

   

    .rc-purchase-option__badge {
      display: none;
    }

    .compact .rc-purchase-option__prices {
      flex-direction: row !important;
      gap: 8px;
      align-items: center !important;
      margin-left: 0px;
    }

    @media screen and (max-width: 768px) {
      .compact .rc-purchase-option__prices {
        flex-direction: column !important;
        gap: 0px;
        align-items: stretch !important;
      }

       .compact.rc-selection__root {
        font-size: 17px !important;
      }
    }

    .compact .rc-purchase-option__label {
      border-top: 1px dotted rgba(0, 0, 0, 0.12);
      padding: 14px 0 !important;
      flex-wrap: wrap;
    }

    .rc-purchase-option__subscription .rc-purchase-option__label {
      padding: 14px 0 0 !important;
    }

    @media screen and (max-width: 768px) {
      .compact .rc-purchase-option__label {
        font-size: 17px !important;
      }
    }

    .rc-price::after {
      content: 'GBP';
      color: #000;
      font-family: Masqualero;
      font-size: 12.694px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
      margin-left: 4px;
    }

    .rc-purchase-option__subscription .rc-price::after {
      margin-left: 0px;
    }

    .rc-price.strike-through {
      color: rgba(0, 31, 25, 0.70);
      text-align: center;
      font-family: Masqualero;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      text-decoration-line: line-through;
      margin-top: 1px;
    }

    @media screen and (max-width: 768px) {
      .rc-price.strike-through {
        text-align: right;
        margin-top: 0px;
      }
    }

    .rc-price.strike-through::after {
      display: none;
    }

    .compact rc-learn-more {
      display: flex;
    }

    rc-learn-more::after {
      content: 'RECOMMENDED';
      color: #fff;
      text-align: center;
      font-family: Avenir, 'TTNorms';
      font-size: 12px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      text-transform: uppercase;
      display: flex;
      padding: 6px 14px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 78px;
      background: #DC4C55;
    }

    @media screen and (max-width: 768px) {
      rc-learn-more::after {
        background: #DC4C55;
        position: absolute;
        top: 50px;
        left: 0;
        font-size: 9.3px;
      }
    }

     @media screen and (max-width: 1250px) {
      rc-learn-more::after {
        font-size: 10px;
        padding: 6px;
      }
    }

    @media screen and (max-width: 768px) {
      .rc-purchase-option__subscription > .rc-purchase-option__label {
        padding-bottom: 30px !important; 
      }
    }

    .rc-purchase-option__sub-container {
      padding-inline: 0 !important;
      padding-bottom: 16px !important;
      border-bottom: 1px dotted rgba(0, 0, 0, 0.12);
      gap: 12px !important;
    }

    .rc-purchase-option__sub-container::after {
      content: 'Our flexible subscription has no minimum term and can be cancelled or adjusted at any time.';
      color: #000;
      font-family: "TTNorms";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .rc-purchase-option__selector {
      font-size: 16px !important;
    } 

    @keyframes pdp-sticky-enter-rc {
      from {
        transform: translateY(100%) !important;
      }

      to {
        transform: translateY(0) !important;
      }
    }

    @keyframes pdp-sticky-exit-rc {
      from {
        transform: translateY(0) !important;
      }

      to {
        transform: translateY(100%) !important;
      }
    }

    @keyframes pdp-sticky-exit-rc-mobile {
      from {
        transform: translateY(0) !important;
        opacity: 1 !important;
      }

      to {
        transform: translateY(calc(100% + 134px)) !important;
        opacity: 0 !important;
      }
    }

    .fixedOnScroll {
      position: fixed !important;
      bottom : -3px !important;
      left: 300px !important;
      z-index: 100 !important;
      background: white !important;
      transform: translateY(100%) !important;
    }

    .fixedOnScroll.fixedOnScroll--visible:not(.fixedOnScroll--concealed):not(.fixedOnScroll--animating-in):not(.fixedOnScroll--animating-out) {
      transform: translateY(0) !important;
    }

    .fixedOnScroll.fixedOnScroll--animating-in {
      animation: pdp-sticky-enter-rc 0.24s cubic-bezier(0.33, 0, 0.2, 1) forwards !important;
    }

    .fixedOnScroll.fixedOnScroll--animating-out {
      animation: pdp-sticky-exit-rc 0.24s cubic-bezier(0.33, 0, 0.2, 1) forwards !important;
    }

    .fixedOnScroll.fixedOnScroll--concealed {
      transform: translateY(100%) !important;
      opacity: 0 !important;
      pointer-events: none !important;
      transition:
        transform 0.24s cubic-bezier(0.33, 0, 0.2, 1) !important,
        opacity 0.25s ease !important;
    }

    @media (prefers-reduced-motion: reduce) {
      .fixedOnScroll.fixedOnScroll--animating-in,
      .fixedOnScroll.fixedOnScroll--animating-out {
        animation: none !important;
      }
    }

    @media screen and (max-width: 1300px) {
      .fixedOnScroll {
        left: 200px !important;
      }
    }

     @media screen and (max-width: 1220px) {
      .fixedOnScroll {
        bottom: 0px !important;
        transform: translateY(100%) !important;
      }

      .fixedOnScroll.fixedOnScroll--concealed {
        transform: translateY(100%) !important;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll {
        bottom: 114px !important; /* posicion selector: subscription (default) */
        left: 0 !important;
        width: 100%;
        padding: 0 22px;
        box-sizing: border-box;
        transform: translateY(100%) !important;
        transition: bottom 0.3s cubic-bezier(0.33, 0, 0.2, 1) !important;
      }

      .fixedOnScroll.fixedOnScroll--onetime {
        bottom: 67px !important; /* posicion selector: one time seleccionado */
      }

      .fixedOnScroll.fixedOnScroll--concealed {
        transform: translateY(100%) !important;
      }

      .fixedOnScroll .rc-purchase-option {
        width: 100%;
      }
    }


    .fixedOnScroll .compact.rc-selection__root {
      display: flex !important;
      align-items: center !important;
      gap: 20px !important;
      min-height: 74px;
    }

     @media screen and (max-width: 1220px) {
      .fixedOnScroll .compact.rc-selection__root {
        gap: 0px !important;
        align-items: flex-start !important;
        min-height: 124px;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll .compact.rc-selection__root {
        gap: 8px !important;
        min-height: 0;
      }
    }

    .fixedOnScroll .rc-purchase-option__selector {
      height: 33px;
    }

    .fixedOnScroll .rc-purchase-option__sub-container::after {
      display: none !important; 
    }

    .fixedOnScroll .compact .rc-purchase-option__prices {
      display: none !important;
    }

    .fixedOnScroll .rc-purchase-option__subscription {
      display: flex !important;
      align-items: center !important;
    }

    @media screen and (max-width: 1220px) {
      .fixedOnScroll .rc-purchase-option__subscription {
        flex-direction: column !important;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll .rc-purchase-option__subscription {
        position: static !important;
      }
    }

    .fixedOnScroll .rc-purchase-option__sub-container {
        padding: 18px !important;
        justify-content: center;
        border: 0;
    }

    @media screen and (max-width: 990px) {
      .fixedOnScroll .rc-purchase-option__sub-container {
          padding: 0px 20px !important;
          position: absolute;
          bottom: -46px;
          left: 0;
          width: 100%;
          box-sizing: border-box;
      }

      .fixedOnScroll .rc-purchase-option__label {
        border: none !important;
      }

      .fixedOnScroll .rc-purchase-option{
        border: 1px solid rgba(0, 0, 0, 0.12) !important;
      }
    }

    .fixedOnScroll .rc-purchase-option__sub-container .rc-plans-dropdown__select{
        border: none !important;
    }

    .fixedOnScroll rc-learn-more::after {
      content: '15% OFF' !important;
    }

  

    .fixedOnScroll .compact .rc-purchase-option__label {
      border: 1px solid rgba(0, 0, 0, 0.12);
      padding: 4px 20px !important;
      height: 40px !important;
    }

    .fixedOnScroll .rc-plans-dropdown__first-time-gift {
      display: none;
    }

      @media screen and (max-width: 990px) {
      .fixedOnScroll rc-learn-more::after{
        top: -11px;
        left: auto;
        right: 9px;
      }

       .fixedOnScroll .compact .rc-purchase-option__label {
      border: 1px solid rgba(0, 0, 0, 0.12);
      padding: 0px 20px !important;
      height: 38px !important;
    }
      
    }


  `;
  shadow.appendChild(style1);
  widget?.dispatchEvent(new CustomEvent('recharge-pdp:content-updated', { bubbles: true }));

  // Keep (re)applying inner-shadow styles and benefit blocks on an interval.
  // Recharge destroys and recreates rc-selling-plans (and can re-render the
  // purchase options) when the selected option changes, dropping our injected
  // styles/nodes. Each step below is idempotent, so we never clear this interval.
  const PLANS_DROPDOWN_STYLE_ID = 'rc-plans-dropdown-styles';

  const checkSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_rc_gift)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="currentColor"></path></g><defs><clipPath id="clip0_rc_gift"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg>';

  const createGiftLine = (text) => {
    const line = document.createElement('div');
    line.className = 'rc-gift-line';
    line.innerHTML = checkSvg + '<span>' + text + '</span>';
    return line;
  };

  const createGiftContainer = (lines, extraClass = '') => {
    const giftDiv = document.createElement('div');
    giftDiv.className = ['rc-plans-dropdown__first-time-gift', extraClass].filter(Boolean).join(' ');
    lines.forEach((text) => giftDiv.appendChild(createGiftLine(text)));
    return giftDiv;
  };

  const applyGiftBenefitStyles = () => {
    if (shadow.querySelector('#rc-gift-benefit-styles')) return;

    const giftStyle = document.createElement('style');
    giftStyle.id = 'rc-gift-benefit-styles';
    giftStyle.textContent = `
      .rc-plans-dropdown__first-time-gift {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-family: 'TTNorms', sans-serif;
        font-size: 13px;
        color: #121212;
        margin-left: 3px;
      }
      @media screen and (max-width: 1250px) {
        .rc-plans-dropdown__first-time-gift {
          font-size: 13px;
        }
      }
      .rc-gift-line {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .rc-gift-line svg {
        flex-shrink: 0;
        color: #1212129c;
      }
    `;
    shadow.appendChild(giftStyle);
  };

  const applyGiftBenefitBlocks = () => {
    const oneTimeBlock = shadow.querySelector('.rc-purchase-option:not([class*="subscription"])');
    const oneTimeLabel = oneTimeBlock?.querySelector('.rc-purchase-option__label') || oneTimeBlock?.querySelector('[class*="rc-purchase-option__label"]');

    if (oneTimeBlock && oneTimeLabel && !oneTimeBlock.querySelector('.rc-onetime-shipping-benefit')) {
      const oneTimeGiftDiv = createGiftContainer(['Free delivery on orders over £30'], 'rc-onetime-shipping-benefit');
      oneTimeLabel.insertAdjacentElement('afterend', oneTimeGiftDiv);
      widget?.dispatchEvent(new CustomEvent('recharge-pdp:content-updated', { bubbles: true }));
    }

    // Label must be inside the subscription option, not one-time (rc-purchase-option_subscription / rc-purchase-option__subscription)
    const subscriptionBlock = shadow.querySelector('.rc-purchase-option_subscription') || shadow.querySelector('.rc-purchase-option__subscription');
    const purchaseOptionLabel = subscriptionBlock?.querySelector('.rc-purchase-option__label') || subscriptionBlock?.querySelector('[class*="rc-purchase-option__label"]');

    if (subscriptionBlock && purchaseOptionLabel && !subscriptionBlock.querySelector('.rc-subscription-benefits')) {
      const lines = [
        'Save at least 15% on each order',
        'Free delivery on orders over £30',
        'Free gifts, products and early access',
        'Pause, skip or cancel anything',
      ];

      const giftDiv = createGiftContainer(lines, 'rc-subscription-benefits');
      purchaseOptionLabel.insertAdjacentElement('afterend', giftDiv);
      widget?.dispatchEvent(new CustomEvent('recharge-pdp:content-updated', { bubbles: true }));
    }
  };

  const applyPlansDropdownStyle = () => {
    const sellingPlans = shadow.querySelector('rc-selling-plans');
    const innerShadow = sellingPlans?.shadowRoot;
    if (!innerShadow) return;

    const dropdown = innerShadow.querySelector('.rc-plans-dropdown__select');
    if (!dropdown) return;

    // Re-injected whenever Recharge recreates the inner shadow (new shadow root
    // won't contain our marked style element).
    if (innerShadow.querySelector(`#${PLANS_DROPDOWN_STYLE_ID}`)) return;

    const style2 = document.createElement('style');
    style2.id = PLANS_DROPDOWN_STYLE_ID;
    style2.textContent = `
      .rc-plans-dropdown__select {
        font-family: 'TTNorms', sans-serif !important;
        padding-block: 10px !important;
        border: 1px solid rgba(0, 0, 0, 0.13) !important;
        font-size: 14px !important;
      }
    `;
    innerShadow.appendChild(style2);
  };

  setInterval(() => {
    applyPlansDropdownStyle();
    applyGiftBenefitStyles();
    applyGiftBenefitBlocks();
  }, 300);
};

const widget = document.querySelector('recharge-subscription-widget');

// Main initialization for styles
const waitForWidget = setInterval(() => {
  const shadow = widget?.shadowRoot;
  if (!shadow) return;

  const hasContent = shadow.querySelector('.rc-purchase-option');
  if (!hasContent) return;

  clearInterval(waitForWidget);

  // Apply styles
  applyStyles(shadow);
}, 300);


